module.exports = __webpack_public_path__ + "media/entities/1012-3df4084a.png";